var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import IndexGrid from '../../components/IndexGrid';
import Draggable from '../../components/Draggable';
import Text from '../../components/TextWithAudio';
import derangeObjectArrayById from '../../lib/derangeObjectArrayById';

var AnswerDualOrder = function (_Component) {
  _inherits(AnswerDualOrder, _Component);

  function AnswerDualOrder(props) {
    _classCallCheck(this, AnswerDualOrder);

    var _this = _possibleConstructorReturn(this, (AnswerDualOrder.__proto__ || Object.getPrototypeOf(AnswerDualOrder)).call(this, props));

    _this.state = {
      shuffledElements: derangeObjectArrayById(props.textElementsRight)
    };
    return _this;
  }

  _createClass(AnswerDualOrder, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.props.id !== nextProps.id || this.context.enteredAnswer !== null && nextContext.enteredAnswer === null) {
        this.setState({
          shuffledElements: derangeObjectArrayById(nextProps.textElementsRight)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          textElementsLeft = _props.textElementsLeft,
          rightOnly = _props.rightOnly;
      var shuffledElements = this.state.shuffledElements;

      return React.createElement(
        IndexGrid,
        { theme: 'dualColumn' },
        React.createElement(
          'div',
          null,
          React.createElement(
            Draggable,
            { id: 1, inactive: rightOnly },
            textElementsLeft.map(function (textElement) {
              return React.createElement(Text, Object.assign({ key: textElement.id }, textElement, { showDragIcon: !rightOnly, showBorder: true, theme: 'grid' }));
            })
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            Draggable,
            { id: 2 },
            shuffledElements.map(function (textElement) {
              return React.createElement(Text, Object.assign({ key: textElement.id }, textElement, { showDragIcon: true, theme: 'grid' }));
            })
          )
        )
      );
    }
  }]);

  return AnswerDualOrder;
}(Component);

export default AnswerDualOrder;


AnswerDualOrder.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.number.isRequired,
  textElementsLeft: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    audioSource: PropTypes.string
  })),
  textElementsRight: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    audioSource: PropTypes.string
  })),
  rightOnly: PropTypes.bool
} : {};

AnswerDualOrder.defaultProps = {
  textElementsLeft: [],
  textElementsRight: [],
  rightOnly: true
};

AnswerDualOrder.contextTypes = {
  enteredAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
};